export type AppErrorData =
  | {
      type: 'NOT_FOUND'
      message?: string
    }
  | {
      type: 'INVALID_ARGUMENTS'
      message?: string
    }

export class AppError extends Error {
  static throw(data: AppErrorData): never {
    throw new this(data)
  }

  constructor(public data: AppErrorData, cause?: unknown) {
    super(JSON.stringify(data))
    this.name = this.constructor.name
    this.cause = cause
  }
}
